import React from "react";
import { Card, Row, Col, Tag } from "antd";

const ViewCustomFields = ({ customFields = [] }) => {
  if (!Array.isArray(customFields) || customFields.length === 0) return null;

  const replaceLineBreaks = (text) =>
    text?.replace(/\n/g, "<br/>") ?? "";

  // ✅ sort by custom_field.sort
  const sorted = [...customFields].sort((a, b) => {
    const sa = Number(a.custom_field?.sort ?? 0);
    const sb = Number(b.custom_field?.sort ?? 0);
    return sa - sb;
  });

  const sections = [];
  let currentSection = null;

  sorted.forEach((item) => {
    const type = item.custom_field?.type;

    if (type === "Section") {
      // push previous section (if exists)
      if (currentSection && currentSection.fields.length > 0) {
        sections.push(currentSection);
      }
      // start a new section
      currentSection = { title: item.custom_field.label, fields: [] };
    } else {
      // if no section defined yet, create "General"
      if (!currentSection) {
        currentSection = { title: "General", fields: [] };
      }
      currentSection.fields.push(item);
    }
  });

  // push last section if exists
  if (currentSection && currentSection.fields.length > 0) {
    sections.push(currentSection);
  }

  return (
    <>
      {sections.map((section, idx) => (
        <Card key={idx} title={section.title} className="mb-10">
          <Row gutter={[16, 16]}>
            {section.fields.map((field) => {
              const type = field.custom_field?.type || "Input";
              const colSpan = type === "Textarea" ? 12 : 6;

              return (
                <Col
                  key={field.id ?? `cf-${field.custom_field?.id}`}
                  xs={24}
                  sm={12}
                  md={colSpan}
                  lg={colSpan}
                  className="mb-20"
                >
                  <p className="fs-12 mb-10 bold">
                    {field.custom_field?.label || "Field"}
                  </p>

                  {field.value ? (
                    type === "Multi" ? (
                      field.value.split(",").map((val) => (
                        <Tag key={val.trim()} color="blue" className="mb-5">
                          {val.trim()}
                        </Tag>
                      ))
                    ) : (
                      <div
                        style={{ wordBreak: "break-word" }}
                        dangerouslySetInnerHTML={{
                          __html: replaceLineBreaks(field.value),
                        }}
                      />
                    )
                  ) : (
                    "-"
                  )}
                </Col>
              );
            })}
          </Row>
        </Card>
      ))}
    </>
  );
};

export default ViewCustomFields;
